import { useMemo } from 'react';
import { RouterProvider } from 'react-router/dom';
import { router } from '../router';
import { AuthProvider, useAuth } from '../context/AuthContext';
import FeatureConfigContext, {
  FeatureConfigProvider,
  useFeatureConfig,
} from '../context/FeatureConfigContext';
import {
  PUBLIC_MAX_FREQUENCY,
  PUBLIC_MIN_FREQUENCY,
  isFrequencyWithinRange,
} from '../constants/frequencies';

function AppContent() {
  return <RouterProvider router={router} />;
}

function GuestFeatureGate({ children }) {
  const base = useFeatureConfig();
  const { isAuthenticated, isLoading } = useAuth();

  const value = useMemo(() => {
    if (isLoading || isAuthenticated) {
      return base;
    }

    const withinFreeRange = (frequency) =>
      isFrequencyWithinRange(frequency, PUBLIC_MIN_FREQUENCY, PUBLIC_MAX_FREQUENCY);

    return {
      ...base,
      isFrequencyPlayable: (frequency) =>
        base.isFrequencyPlayable(frequency) && withinFreeRange(frequency),
      isFrequencyInteractable: (frequency) =>
        base.isFrequencyInteractable(frequency) && withinFreeRange(frequency),
      canEditScenario: false,
    };
  }, [base, isAuthenticated, isLoading]);

  return (
    <FeatureConfigContext.Provider value={value}>
      {children}
    </FeatureConfigContext.Provider>
  );
}

function AppShell({ featureConfigValue }) {
  return (
    <FeatureConfigProvider value={featureConfigValue}>
      <AuthProvider>
        <GuestFeatureGate>
          <AppContent />
        </GuestFeatureGate>
      </AuthProvider>
    </FeatureConfigProvider>
  );
}

export default AppShell;


